import { gql } from '@urql/core';
import Image, { ImageProps } from 'next/image';
import { buildFileUrlOrNull } from '../../../client/images.utils';
import { SpinContentImageDisplayFragment } from '../../../generated/spin-graphql';
gql`
    fragment SpinContentImageDisplay on content_file {
        id
        cdn_url
        ext
    }
`;

export function SpinContentImageDisplay({
    img,
    fallbackImage,
    alt = 'Spin',
    ...rest
}: {
    img: SpinContentImageDisplayFragment;
    alt?: string;
    fallbackImage?: string;
} & Omit<ImageProps, 'src'>) {
    const url = buildFileUrlOrNull(img) ?? fallbackImage;
    if (url) {
        return <Image alt={alt} {...rest} src={url} />;
    }
    return <></>;
}
